import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Barboon**
 *
 * @exports bs_369
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let barboonObserver;
    /**
       * @memberOf module:bs_369
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        if (thn.widgets.price.isSet()) {
            thn.widgets.price.reset();
        }
        setTimeout(thn.pageCheck, 400);
    };
    /**
       * @memberOf module:bs_369
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        const container = document.documentElement;
        if (container) {
            const langCurrencyChange = thn.debounce(() => {
                thn.pageCheck();
                thn.languageCheck();
                if (thn.data.pageName === 'Rooms and Rates') {
                    setTimeout(() => thn.widgets.price.refresh(), 800);
                }
            }, 1000);
            const handler = function (mutations) {
                const mutationLangChange = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target?.className?.match(/language-menu-container|application-portal/)).filter(Boolean);
                const mutationCurrencyChange = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target?.className?.match(/currency-menu-container|application-portal/)).filter(Boolean);
                const mutationNoAvailability = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target?.className?.match(/page-layout-container-wrapper-content/)?.childNods?.[0]?.match(/suggestions-container/)).filter(Boolean);
                if (mutationLangChange.length || mutationCurrencyChange.length || mutationNoAvailability.length) {
                    langCurrencyChange();
                }
            };
            thn.observeDom(container, handler, {
                childList: true,
                subtree: true,
                characterData: false,
                attributes: true,
            });
            thn.shutdown(() => {
                langCurrencyChange.cancel();
                thn.stopObserveDom(container, handler);
            });
        }
        function storeBookingData(result) {
            if ((result.pageName === 'User Register Page' || window.location.pathname === '/guest-detail') && thn.data.media.name === 'mobile' && thn.supports('local_storage')) {
                window.localStorage.setItem('thn_data', JSON.stringify({
                    dateBegin: thn.parseUrlParameter('checkIn').replace(/-/g, '/'),
                    dateEnd: thn.parseUrlParameter('checkOut').replace(/-/g, '/'),
                }));
            }
        }
        thn.bus.on('thn:page.set', storeBookingData);
        thn.shutdown(function () {
            thn.bus.detach('thn:page.set', storeBookingData);
        });
        // sold-out message does not disappear when loading new dates
        const onPriceSet = ({ changed, firstTime }) => {
            if (changed && !firstTime) {
                thn.widgets.layer.destroy();
            }
        };
        const eventName = 'thn:price.set';
        thn.bus.on(eventName, onPriceSet);
        thn.shutdown(() => {
            thn.bus.detach(eventName, onPriceSet);
        });
    };
    /**
       * @memberOf module:bs_369
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#app, .search-form-wrapper, .room-list-container, .basket-wrapper-room');
        if (container && !barboonObserver) {
            thn.languageCheck();
            barboonObserver = thn.debounce(() => ctx.widget.refresh(), 500);
            thn.observeDom(container, barboonObserver, {
                childList: true,
                subTree: true,
                attributes: true,
                characterData: true,
            });
            thn.pageUnload(() => {
                barboonObserver.cancel();
                thn.stopObserveDom(container, barboonObserver);
                barboonObserver = null;
            });
        }
    };
    /**
       * @memberOf module:bs_369
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const langDictionary = {
                English: 'en',
                Türkçe: 'tr',
                'Search Result': 'en',
                'Arama Sonuçları': 'tr',
                ARA: 'tr',
                SEARCH: 'en',
            };
            const langSel = document.querySelector('.current-language, .title-container, .search-form .simprakit-button-wrapper-content')?.textContent;
            const language = langSel && langDictionary[langSel];
            if (language && ctx.langs.test(language)) {
                resolve(language);
                return;
            }
            reject('no_language');
        });
    };
    /**
    * @memberOf module:bs_369
    * @this thn.widgets.price
    * @see {@link Price#set_data}
    *
    * @param {object} ctx - The context object.
    */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        const isTheStayHotels = thn.data.accountUserId === 1044233;
        // Dates
        const dateBegin = thn.parseUrlParameter('checkIn')?.replace(/-/g, '/');
        const dateEnd = thn.parseUrlParameter('checkOut')?.replace(/-/g, '/');
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        let adults = thn.parseNumber(thn.parseUrlParameter('adultCount'));
        let children = thn.parseNumber(thn.parseUrlParameter('childCount'));
        const rooms = document.querySelectorAll('.basket-wrapper-room');
        const childrenAges = window.location.search?.split('&')?.filter((param) => param?.includes('childAge'))?.map((age) => age?.split('='));
        const childrenAgesObject = !thn.empty(childrenAges) && typeof childrenAges === 'object' && Object.fromEntries(childrenAges);
        const roomActivated = { ...[...rooms].map((el) => el?.className?.includes('active')) };
        const activatedRoomIndex = Object.keys(roomActivated)?.find((key) => roomActivated[key]);
        // In multiple rooms case, count only active room's guests.
        if (rooms && rooms.length > 1) {
            adults = thn.parseNumber(document.querySelector('.basket-wrapper-room.active .pax-wrapper .adult')?.textContent);
            children = thn.parseNumber(document.querySelector('.basket-wrapper-room.active .pax-wrapper .child')?.textContent);
        }
        widgetData.adults = adults;
        widgetData.children = children;
        widgetData.guests = adults + children;
        // No availability
        const isNotAvailability = !!document.querySelector('.no-search-result-warning-icon');
        if (isNotAvailability) {
            widgetData.noRooms = true;
            return widgetData;
        }
        if (widgetData.children) {
            const roomInfo = {
                adults: widgetData.adults,
                children: widgetData.children,
                childrenAges: [],
            };
            // children: 6-12, infants: 0-5
            for (let i = 1; i <= widgetData.children; i += 1) {
                roomInfo.childrenAges.push(Object.keys(Object.fromEntries(childrenAges))
                    ?.filter((key) => key?.includes(`childAge${i}Room${thn.parseNumber(activatedRoomIndex) + 1}`))?.reduce((cur, key) => (thn.parseNumber(childrenAgesObject[key]) >= 6 ? 12 : 5), {}));
            }
            widgetData.roomsDispo = [roomInfo];
        }
        // Prices
        const discountedPriceSelector = document.querySelectorAll('.discounted');
        const priceSelector = !thn.empty(discountedPriceSelector) ? discountedPriceSelector : document.querySelectorAll('.rate-original-price, .room .price');
        const pricesArray = [...new Set([...priceSelector]
                .map((price) => thn.parseNumber(price?.textContent)))];
        const price = Math.min(...pricesArray);
        // Currency
        const currency = thn.parseCurrency(document.querySelector('.price, .rate-currency')?.textContent)
            || thn.parseUrlParameter('currency');
        if (!thn.empty(pricesArray) && currency && nights) {
            widgetData.price = isTheStayHotels && thn.data.media.name !== 'mobile' ? price : price / nights;
            widgetData.currency = currency;
            widgetData.roomDetails = engine._roomDetailsParseData(nights);
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
      *
      * @memberOf module:bs_369
      *
      */
    engine._roomDetailsParseData = function roomDetailsParseData(nights) {
        const roomsInfo = document.querySelectorAll('.room-container');
        const roomDetailsArray = [];
        roomsInfo?.forEach((room) => {
            const roomName = room.querySelector('.room-title')?.textContent;
            // there are no guests per room so we default to 2 adults and 0 children
            const roomAdults = 2;
            const roomChildren = 0;
            const roomType = getRoomType(roomName);
            const roomData = {
                id: '',
                name: roomName,
                adults: roomAdults,
                children: roomChildren,
                type: roomType,
                prices: [],
            };
            const ratesInfo = room.querySelectorAll('.rate-list-container .rate-container');
            ratesInfo?.forEach((rate) => {
                const rateName = rate.querySelector('.rate-title')?.textContent;
                const checkBreakfast = rate.querySelector('div > div.rate-info.d-flex > div.rate-title-container > div.d-flex.ai-center > span')?.textContent;
                const price = thn.parseNumber(rate.querySelector('.price.discounted, .rate-row .price')?.textContent);
                let pricePerNight;
                if (price && nights) {
                    pricePerNight = Math.round(price / nights);
                }
                const rateInfo = {
                    id: '',
                    name: rateName,
                    totalNight: pricePerNight,
                    breakfast: (/breakfast|kahvaltı|frühstück/i).test(checkBreakfast),
                    refundable: document.querySelector('.refundable') ? 1 : 0,
                };
                roomData.prices.push(rateInfo);
            });
            roomDetailsArray.push(roomData);
        });
        return roomDetailsArray;
    };
    /**
       * @memberOf module:bs_369
       * @this thn.widgets.booking
       * @see {@link Booking#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingObserveDom = function bookingObserveDom(ctx) {
        const container = document.querySelector('.confirmation-container');
        if (!ctx.widget.isSet()) {
            if (container && !thn.simplebookingBookingObserver) {
                // Create function to delete observer whenever we want
                const stop = function () {
                    if (thn.simplebookingBookingObserver) {
                        thn.stopObserveDom(container, thn.simplebookingBookingObserver);
                        delete thn.simplebookingBookingObserver;
                    }
                };
                thn.simplebookingBookingObserver = thn.debounce(function thnSimplebookingBookingObserver() {
                    if (ctx.widget.setData().isSet()) {
                        ctx.widget.save();
                        stop();
                    }
                }, 250);
                thn.observeDom(container, thn.simplebookingBookingObserver, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['style', 'class'],
                });
                thn.pageUnload(stop);
            }
        }
    };
    /**
    * @memberOf module:bs_369
    * @this thn.widgets.booking
    * @see {@link Booking#set_data}
    *
    * @param {object} ctx - The context object.
    */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // bookingId
        const bookingId = thn.parseUrlParameter('bookingId')
            || document.querySelector('.confirmation-container-reservation-no')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        // Dates & Price & Currency
        const datesArray = [...document.querySelectorAll('.simprakit-datepicker')];
        const priceSel = document.querySelectorAll('.ai-end span');
        if (!thn.empty(datesArray) && !thn.empty(priceSel)) {
            widgetData.dateBegin = datesArray[0].getAttribute('qa-selected-date')?.replace(/-/g, '/');
            widgetData.dateEnd = datesArray[1].getAttribute('qa-selected-date')?.replace(/-/g, '/');
            widgetData.price = thn.parseNumber(priceSel[1]?.textContent);
            widgetData.currency = thn.parseCurrency(priceSel[1]?.textContent);
        }
        else if (thn.supports('local_storage') && thn.data.media.name === 'mobile') {
            const thnData = JSON.parse(window.localStorage.getItem('thn_data'));
            widgetData.dateBegin = thnData.dateBegin;
            widgetData.dateEnd = thnData.dateEnd;
            widgetData.price = thn.parseNumber(document.querySelector('.total-price')?.textContent);
            widgetData.currency = thn.parseCurrency(document.querySelector('.total-price')?.textContent);
            window.localStorage.removeItem('thn_data');
        }
        return widgetData;
    };
    return engine;
}

export { factory };
